import { render } from "./ContactLocation.vue?vue&type=template&id=e8e0ae62&scoped=true"
import script from "./ContactLocation.vue?vue&type=script&lang=js"
export * from "./ContactLocation.vue?vue&type=script&lang=js"

import "./ContactLocation.vue?vue&type=style&index=0&id=e8e0ae62&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8e0ae62"]])

export default __exports__